module.exports = __webpack_public_path__ + "static/img/10areaB_05.8c3eb2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/10areaB_05.png
// module id = 1084
// module chunks = 1